
import {defineComponent} from 'vue';
import {ProgressbarType, TYPE_DEFAULT, TYPES} from './types';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';

export default defineComponent({
  name: 'oxd-progressbar',
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    stripe: {
      type: Boolean,
      default: false,
    },
    animation: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: 0,
      validator: function(value: number) {
        return value >= 0 && value <= 100;
      },
    },
    type: {
      type: String,
      default: TYPE_DEFAULT,
      validator: function(value: ProgressbarType) {
        return TYPES.indexOf(value) !== -1;
      },
    },
  },
  components: {
    'oxd-text': Text,
  },
  computed: {
    styles(): object {
      return {
        width: `${this.progress}%`,
      };
    },
    classes(): object {
      return {
        'oxd-progressbar-ticker': true,
        [`oxd-progressbar-ticker--${this.type}`]: true,
        '--striped': this.stripe,
        '--animated': this.animation,
      };
    },
    progressText(): string {
      return `${Math.round(this.progress)}%`;
    },
  },
});
